import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { matchRequest } from "./utils";

const initialState: State = [];

function handleRequest(
  state: State,
  { timeRecord }: Boundaries["saveTimeRecord"]["request"],
): State {
  const index = state.findIndex((req) => matchRequest(req, timeRecord));

  return index !== -1
    ? [
        ...state.slice(0, index),
        { timeRecord, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { timeRecord, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { timeRecord }: Boundaries["saveTimeRecord"]["success"],
): State {
  const index = state.findIndex((req) => matchRequest(req, timeRecord));

  return index !== -1
    ? [
        ...state.slice(0, index),
        { timeRecord, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { timeRecord, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { timeRecord }: Boundaries["saveTimeRecord"]["failure"],
): State {
  const index = state.findIndex((req) => matchRequest(req, timeRecord));

  return index !== -1
    ? [
        ...state.slice(0, index),
        { timeRecord, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { timeRecord, request: setRequestStateToFailure() }];
}

const reduceState = createStateReducer(initialState, {
  [events.saveTimeRecordRequested]: handleRequest,
  [events.saveTimeRecordSucceeded]: handleSuccess,
  [events.saveTimeRecordFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
